import { ChangeEvent } from 'react';
import { Toggle as RsToggle } from 'rsuite';
import { IsNullOrWhiteSpace } from '@Utils/Micro';
// ---------------------------------------------------------------------------------------------------
export interface ToggleProps {
    key?: string | number;
    label?: string;
    style?: React.CSSProperties;
    toggled?: boolean;
    defaultToggled?: boolean;
    disabled?: boolean;
    onToggle: (isChecked: boolean, event: ChangeEvent) => void;
}
// ---------------------------------------------------------------------------------------------------
export default function Toggle(props: ToggleProps) {
    return (
        <div key={props.key} style={props.style}>
            {IsNullOrWhiteSpace(props.label) ? null
                : <span style={{ marginRight: 4 }}>{props.label}</span>}
            <RsToggle
                style={{ transform: 'scale(0.85)', margin: 0 }}
                checked={props.toggled}
                disabled={props.disabled}
                defaultChecked={props.defaultToggled}
                onChange={(checked, event) => props.onToggle(checked, event)} />
        </div>
    );
}
// ---------------------------------------------------------------------------------------------------